<script setup lang="ts">
import IllustrationHousePayment from './illustrations/IllustrationHousePayment.vue';
</script>

<template>
    <div class="priming-illustration priming-illustration--payment">
        <IllustrationHousePayment class="priming-illustration__svg" />
    </div>
</template>

<style lang="scss" scoped>
@use 'certifid-v2-client-hub-styles' as *;

.priming-illustration {
    width: 100%;
    height: 182px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    overflow: hidden;
    background: var(--ch-primary-lightest, #DEEFF9);
    color: var(--ch-primary, #156FBE);

    &__svg {
        width: 150px;
        height: 143px;
    }
}
</style>
